import { render, staticRenderFns } from "./GoogleCalendar.vue?vue&type=template&id=2c684eba&scoped=true&"
import script from "./GoogleCalendar.vue?vue&type=script&lang=js&"
export * from "./GoogleCalendar.vue?vue&type=script&lang=js&"
import style0 from "./GoogleCalendar.vue?vue&type=style&index=0&id=2c684eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c684eba",
  null
  
)

export default component.exports